import script from "./alarm.vue?vue&type=script&setup=true&lang=js"
export * from "./alarm.vue?vue&type=script&setup=true&lang=js"

import "./alarm.vue?vue&type=style&index=0&id=663c9e60&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663c9e60"]])

export default __exports__